import { getNonce } from 'lib/policy';
import React from 'react';
import { isTruthy } from 'utility/functions';
import styles from './SnaiScoreboard.module.scss';

export type SnaiScoreboardType = {
  isOpen: boolean;
  locale?: string;
  disciplina?: number;
  codProgramme?: number;
  idAvvenimento?: number;
  betRadarMatchId?: number;
  betGeniusMatchId?: number;
};

export const SnaiScoreboard = ({
  isOpen,
  codProgramme,
  idAvvenimento,
  betRadarMatchId,
  betGeniusMatchId,
}: SnaiScoreboardType) => {
  if (!isTruthy(`${process.env.NEXT_PUBLIC_SCOREBOARD_URL ?? ''}`.length)) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <React.Fragment />;
  }
  return (
    <div className={`${styles.content} ${isOpen ? styles.visible : styles.hidden}`}>
      <iframe
        id="snai-frame"
        src={`${process.env.NEXT_PUBLIC_SCOREBOARD_URL}/?pal=${codProgramme}&avv=${idAvvenimento}&br_match_id=${betRadarMatchId}&bg_match_id=${betGeniusMatchId}`}
        width="100%"
        height="100px"
        scrolling="no"
        nonce={getNonce()}
      />
    </div>
  );
};
